module.exports = __webpack_public_path__ + "static/media/Test.086b777a.png";